import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { cn } from '../lib/utils';

interface MobileWarningBannerProps {
  onDismiss?: () => void;
  className?: string;
}

/**
 * Mobile Warning Banner Component
 * Displays a warning message to mobile users that the app is optimized for desktop use.
 * Shown in the login modal to inform users before they proceed with authentication.
 */
export const MobileWarningBanner: React.FC<MobileWarningBannerProps> = ({
  onDismiss,
  className = '',
}) => {
  return (
    <div
      role="note"
      aria-label="Desktop experience recommended"
      className={cn('rounded-2xl border border-warning/25 bg-warning/10 p-3 sm:p-4', className)}
    >
      <div className="flex items-start gap-2 sm:gap-3">
        <AlertTriangle className="mt-0.5 size-5 shrink-0 text-warning sm:size-6" />
        <div className="flex-1">
          <h3 className="mb-1 text-sm font-semibold text-foreground sm:mb-2 sm:text-base">
            Desktop Experience Recommended
          </h3>
          <p className="mb-2 text-xs text-foreground/70 sm:mb-3 sm:text-sm">
            Career Catalyst is optimized for desktop. For the best experience, please use a
            desktop computer.
          </p>
          <p className="mb-3 text-xs text-foreground/55 sm:mb-4">Mobile version coming soon!</p>
          {onDismiss && (
            <button
              type="button"
              onClick={onDismiss}
              className="w-full rounded-lg border border-warning/25 bg-warning/15 px-4 py-2 text-sm font-medium text-warning transition-colors outline-hidden hover:bg-warning/25 focus-visible:ring-3 focus-visible:ring-ring/50 sm:w-auto"
            >
              Continue Anyway
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
